module.exports = __webpack_public_path__ + "static/media/marker.e9f6e510.png";